function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';
import Divider from '../../divider/Divider';
import { MOVE_TO_NEXT, MOVE_TO_PREV, MOVE_TO_FIRST, MOVE_TO_LAST } from '../../hotKeys/constants';
import { ACTION_KEY_MAP } from '../hotKeys';

var HotTabs =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HotTabs, _PureComponent);

  function HotTabs() {
    var _getPrototypeOf2, _defineProperty2;

    var _this;

    _classCallCheck(this, HotTabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HotTabs)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "hotKeyHandlers", (_defineProperty2 = {}, _defineProperty(_defineProperty2, MOVE_TO_NEXT, function (e) {
      return _this.props.onChangeTab(e, MOVE_TO_NEXT);
    }), _defineProperty(_defineProperty2, MOVE_TO_PREV, function (e) {
      return _this.props.onChangeTab(e, MOVE_TO_PREV);
    }), _defineProperty(_defineProperty2, MOVE_TO_FIRST, function (e) {
      return _this.props.onChangeTab(e, MOVE_TO_FIRST);
    }), _defineProperty(_defineProperty2, MOVE_TO_LAST, function (e) {
      return _this.props.onChangeTab(e, MOVE_TO_LAST);
    }), _defineProperty2));

    return _this;
  }

  _createClass(HotTabs, [{
    key: "render",
    value: function render() {
      var tabItems = this.props.tabItems;
      return React.createElement(HotKeys, {
        keyMap: ACTION_KEY_MAP,
        handlers: this.hotKeyHandlers
      }, React.createElement("ul", {
        className: "eds-tabs__navigation eds-l-pad-vert-3 eds-l-mar-bot-3",
        role: "tablist"
      }, tabItems, React.createElement(Divider, null)));
    }
  }]);

  return HotTabs;
}(PureComponent);

_defineProperty(HotTabs, "propTypes", {
  /**
   * List of TabItems with a currently focused tab derived from a focus position
  */
  tabItems: PropTypes.arrayOf(PropTypes.node).isRequired,

  /**
   * Callback that handles the changing of focus on a tab
  */
  onChangeTab: PropTypes.func.isRequired
});

export default HotTabs;